import React from 'react';
import classNames from 'classnames';
import {
  getIsAppBundle,
  getIsPostPageBundle,
  SECTION_CATEGORY,
} from '@wix/communities-blog-client-common';
import { getSection } from '../../selectors/section-selectors';
import AppWrapper from '../app-wrapper';
import { useSelector } from '../runtime-context';
import { type AppProps } from './app-props';
import styles from './app.scss';

type PropsDesktop = {
  desktopHeader?: React.FunctionComponentElement<{ menu?: React.FunctionComponentElement<any> }>;
};

const AppDesktop: React.FC<AppProps & PropsDesktop> = ({
  className,
  desktopHeader,
  main,
  messageRoot,
  modalRoot,
  popoverRoot,
}) => {
  const isPostPageBundle = useSelector(getIsPostPageBundle);
  const isFeedPageBundle = useSelector(getIsAppBundle);
  const section = useSelector(getSection);
  const isCategorySection = section === SECTION_CATEGORY;

  const blogBackgroundColorClassName =
    isFeedPageBundle && isCategorySection
      ? 'blog-background-category-color'
      : 'blog-background-color';

  return (
    <AppWrapper
      className={
        isPostPageBundle
          ? classNames(className, styles.app, styles.postPageRoot)
          : classNames(className, styles.app, blogBackgroundColorClassName)
      }
    >
      {messageRoot}
      {modalRoot}
      {popoverRoot}
      <div id="content-wrapper">
        {desktopHeader}
        {main}
      </div>
    </AppWrapper>
  );
};

export default AppDesktop;
